import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ca363a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "association-profile" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "content-header" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "breadcrumb" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "您的当前位置：", -1))
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "tools" }
const _hoisted_13 = { class: "right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "关键字：", -1))
const _hoisted_15 = { class: "list" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "time" }
const _hoisted_20 = {
  key: 0,
  class: "pagination"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Details = _resolveComponent("Details")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Sidebar, {
            dataSource: _ctx.menuList,
            title: "关于协会",
            subTitle: "About Associations",
            activeIndex: _ctx.activeIndex,
            onSidebarclick: _ctx.sidebarclick
          }, null, 8, ["dataSource", "activeIndex", "onSidebarclick"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.menuList && _ctx.menuList[_ctx.activeIndex]?.name), 1),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_el_breadcrumb, { separator: ">>" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_breadcrumb_item, { to: { path: '/home' } }, {
                    default: _withCtx(() => [
                      _createTextVNode("首页")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_breadcrumb_item, null, {
                    default: _withCtx(() => [
                      _createTextVNode("关于协会")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (!_ctx.isShow)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_el_input, {
                        class: "input",
                        modelValue: _ctx.keyword,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
                        placeholder: "请输入关键字"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.init
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("搜索")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    (_ctx.list?.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.list, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "item",
                            onClick: ($event: any) => (_ctx.openDetails(item))
                          }, [
                            _createElementVNode("img", {
                              class: "triangle",
                              src: _ctx.triangleIcon
                            }, null, 8, _hoisted_17),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(item.title), 1),
                            _createElementVNode("span", _hoisted_19, _toDisplayString(item?.time?.split(" ")[0]), 1)
                          ], 8, _hoisted_16))
                        }), 256))
                      : (_openBlock(), _createBlock(_component_el_empty, {
                          key: 1,
                          "image-size": 150,
                          description: "暂无数据"
                        }))
                  ]),
                  (_ctx.total)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_component_el_pagination, {
                          background: "",
                          layout: "prev, pager, next",
                          total: _ctx.total,
                          onCurrentChange: _ctx.currentChange
                        }, null, 8, ["total", "onCurrentChange"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock(_component_Details, {
                  key: 1,
                  "current-item": _ctx.currentItem,
                  loading: _ctx.loading
                }, null, 8, ["current-item", "loading"]))
          ])
        ])
      ])
    ])
  ]))
}